import { Outlet } from "react-router-dom";
import SidebarLayout from "../../components/common/layout/SidebarLayout";
import { projectMenus } from "../../components/layout/ProjectMenus";

export default function FourDLayout() {
  const { title, base, sections } = projectMenus.fourd;

  return (
    <SidebarLayout
      title={title}
      base={base}
      sections={sections}
    >
      <Outlet />
    </SidebarLayout>
  );
}
